/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { EditorContext } from "../../Context/EditorContext";
import Nav from "../Nav/Nav";
import SideSettings from "../SideSettings/SideSettings";
import CodeOutput from "../CodeOutput/CodeOutput";

const Hero = () => {
  const { layout, outputWidth, html, css } = useContext(EditorContext);

  return (
    <section
      style={{
        flexDirection: layout === "Right" ? "row-reverse" : "row",
        background: html || css !== "" ? "#fff" : "#3b3f4c",
      }}
      className="hero"
      css={styles}
    >
      <p className="outputWidth">{outputWidth && outputWidth + "px"}</p>
      <Nav />
      <SideSettings />
      <CodeOutput />
    </section>
  );
};

const styles = css`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  transition: background 1500ms ease-in-out;
  .outputWidth {
    position: absolute;
    color: #fff;
    font-size: 20px;
    top: 96px;
    right: 10px;
    z-index: 500;
  }
`;

export default Hero;
